<template>
    <button
    class="base-btn"
    @click="$emit('click', $event)"
    :type="type"
    :disabled="disabled"
    :variant="variant"
    >
        <slot> </slot>
    </button>
</template>
<script>
export default {
  name: 'BaseButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'info',
    },
    type: {
      type: String,
      default: 'info',
    },
  },
};
</script>

<style scoped>
.base-btn{
 line-height: 1;
  text-align: center;
   padding: 10px;
  font-family: Arial;
  font-size: 15px;
  color: #ffffff;
  background: #bd9d5f;
  border: unset;
   border-radius: 2px;
}
</style>
